import { FONTS, COLORS } from '../../constants';

// eslint-disable-next-line arrow-body-style
const styles = theme => {
  return {
    root: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      zIndex: 9,
    },
    drawerPaper: {
      backgroundColor: COLORS.GREY_DARK,
    },
    hamburger: {
      color: COLORS.WHITE,
    },
    appTitle: {
      flexGrow: 1,
      textTransform: 'none',
    },
    verticalSep: {
      width: '1px',
      height: '40px',
      backgroundColor: '#ffffff',
      marginLeft: '0.25rem',
      marginRight: '1rem',
    },
    menuButton: {
      marginLeft: -12,
      marginRight: 20,
      fontSize: 16,
      alignItems: 'center',
      [theme.breakpoints.down('xs')]: {
        marginRight: -3,
      },
      '&:hover': {
        borderRadius: '0',
        background: 'none',
        '& span': {
          padding: '6px 0',
          borderBottom: '3px solid #009a44',
        },
      },
    },
    bottomButton: {
      fontSize: 16,
      color: '#ffffff',
    },
    topBar: {
      padding: '0 8px',
      display: 'flex',
      backgroundColor: COLORS.GREEN,
      // logo icon
      '& > button > span > a': {
        display: 'inherit',
      },
    },
    topBar_loggedOut: {
      padding: '12px 20px',
      display: 'flex',
      backgroundColor: COLORS.GREEN,
    },
    topLeftButtons: {
      paddingLeft: 0,
      paddingRight: 0,
      marginLeft: 10,
      marginRight: 20,
      borderRadius: 0,
      fontFamily: FONTS.PRIMARY,
      borderBottom: '3px solid #ffffff',
      transition: 'none',
      '&:hover': {
        borderBottom: '3px solid #009a44',
        background: 'none',
      },
    },
    buttonUnderline: {
      borderBottom: '3px solid #009a44',
    },
    topRightButton: {
      color: '#ffffff',
      marginLeft: -12,
      marginRight: 0,
      fontSize: 16,
      alignItems: 'center',
      '&:hover': {
        borderRadius: '0',
        background: 'none',
        '& span': {
          padding: '6px 0',
          borderBottom: '3px solid #009a44',
        },
      },
    },
    bottomBar: {
      top: 'auto',
      bottom: 0,
      backgroundColor: '#4d4d4d',
    },
    bottomText: {
      fontFamily: '"Helvetica Neue", Arial',
      color: '#ffffff',
      marginTop: 0,
      fontSize: 12,
    },
    topIcons: {
      paddingRight: 3,
      [theme.breakpoints.down('xs')]: {
        transform: 'scale(1.2)',
      },
    },
    bottomIcons: {
      [theme.breakpoints.down('xs')]: {
        transform: 'scale(1.2)',
      },
    },
  };
};

export default styles;
